exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js!./labvariables.css"), "");
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js!./widgets-base.css"), "");
// Module
exports.push([module.id, "/* Copyright (c) Jupyter Development Team.\n * Distributed under the terms of the Modified BSD License.\n */\n", ""]);
